import { Collapse, Modal, Radio, InputNumber, Slider, Form, Input } from 'antd';
import { CaretRightOutlined, RightOutlined } from '@ant-design/icons';
import lightIcon from '@/assets/img/hdd/light.png';
import { getCondition } from '@/api/hdd/leftPanel';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import { useStoreState } from '&/utils/customHooks';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './renderParams.scss';

const { Panel } = Collapse;

/**
 * 解析 HDD noticeExteriorParams 入参。
 * 标准扁平结构：{ id, name, path, rotate, envBright, envReflect, envTone, exteriorBright }
 * 亦兼容 { exterior: { ... } } 嵌套。
 */
function parseNoticeExteriorParams(params) {
    let data = params;
    if (typeof params === 'string') {
        try {
            data = JSON.parse(params);
        } catch {
            return null;
        }
    }
    if (!data || typeof data !== 'object') return null;

    const ext =
        data.exterior && typeof data.exterior === 'object' ? data.exterior : {};

    const id = ext.id ?? data.id;
    if (id == null || id === '') return null;

    const pick = key => {
        if (ext[key] !== undefined && ext[key] !== null) return ext[key];
        if (data[key] !== undefined && data[key] !== null) return data[key];
        return undefined;
    };

    return {
        id: String(id),
        path: pick('path'),
        name: pick('name'),
        rotate: pick('rotate'),
        envBright: pick('envBright'),
        envReflect: pick('envReflect'),
        envTone: pick('envTone'),
        exteriorBright: pick('exteriorBright'),
    };
}

export default function RenderParams() {
    const appStore = useStoreState('appStore');
    const [clearMoreSetting, setClearMoreSetting] = useState(false);

    usePreventDefault();

    const showGiveModal = async () => {
        try {
            const { data } = await getUserInfo();
            if (
                data.type !== 1 ||
                data.newUserGift?.includes('rendering_voucher_free')
            ) {
                return; // 非个人用户或已经领取过新人大礼包则不展示
            }
            // 通知HDD展示新人大礼包
            window.external.DispatchFun(
                'LeftPanel',
                'Render',
                JSON.stringify({
                    Url: `${window.location.origin}/hdd/giveRenderingCoupons?token=${appStore?.token}`,
                    Width: 344,
                    Height: 520,
                })
            );
        } catch {}
    };

    const openBuyCouponsModal = async e => {
        e.stopPropagation();
        try {
            const res = await getUserInfo();
            let sendData = {};
            const urlParams = `?token=${appStore?.token}`;
            if (res.data.type === 1) {
                const url = `${window.location.origin}/hdd/renderingCouponsList`;
                sendData = {
                    Url: `${url}${urlParams}`,
                    Width: 900,
                    Height: 634,
                };
            } else {
                const url = `${window.location.origin}/hdd/consultQRCodeModal`;
                sendData = {
                    Url: `${url}${urlParams}`,
                    Width: 360,
                    Height: 400,
                };
            }
            window.external.DispatchFun(
                'LeftPanel',
                'Render',
                JSON.stringify(sendData)
            );
        } catch (e) {}
    };
    const extra = (
        <>
            <img src={require('@/assets/img/hdd/discount.png').default}></img>
            <span onClick={openBuyCouponsModal} className="blue-color">
                购买
            </span>
            <span className="normal-color"> / 剩余</span>
        </>
    );

    const [resolutionList, setResolutionList] = useState([]);
    const [compositionList, setCompositionList] = useState([]);
    const [exteriorList, setExteriorList] = useState([]);
    const [exterior, setExterior] = useState();
    const renderType =
        new URLSearchParams(window.location.search).get('renderType') || 0;
    const compositionRef = useRef(null);
    /** 外部 HDD 注入（noticeExteriorParams / noticeLightingList）时跳过回传 setRenderParams */
    const suppressHddNotifyFromExternalRef = useRef(false);

    const onKeydown = () => {
        console.log(222);
        try {
            window.external.DispatchFun('Atlas', 'HideMoreSettingWindow', '');
        } catch (e) {}
    };

    useEffect(() => {
        showGiveModal();
        getCondition({ renderType }).then(res => {
            console.log('res', res);
            if (!res.data) return;
            setResolutionList(res.data.resolution);
            setResolution(res.data.resolution[0].value);
            setCompositionList(res.data.pixelAspect);
            setComposition(res.data.pixelAspect[0]?.value);
            compositionRef.current = res.data.pixelAspect[0]?.value;
            setExteriorList(res.data.outdoorScene);
            setExterior(res.data.outdoorScene[0].value);
        });

        /**
         * HDD 外部调用：仅同步布光方案列表与选中态，不回传 setRenderParams。
         * 入参为 JSON 字符串或数组，项含 name、id、active 等字段。
         */
        window.noticeLightingList = function (params) {
            try {
                let list =
                    typeof params === 'string' ? JSON.parse(params) : params;
                if (!Array.isArray(list)) return;

                const normalized = list.map(v => ({
                    ...v,
                    img: lightIcon,
                }));
                const curLight = normalized.find(v => +v.active === 1);

                suppressHddNotifyFromExternalRef.current = true;
                setLightList(normalized);

                if (curLight) {
                    setOperateLight({
                        status: 'active',
                        id: curLight.id,
                        name: curLight.name,
                    });
                } else {
                    setOperateLight({
                        status: 'none',
                        id: '',
                        name: '',
                    });
                }
            } catch (e) {
                console.warn('noticeLightingList', e);
            }
        };
        // hdd 调用更新渲染券
        window.refreshRenderTicket = function () {
            getCondition({
                renderType,
                compositionValue: compositionRef.current,
            }).then(res => {
                if (!res.data) return;
                setResolutionList(res.data.resolution);
            });
        };

        // hdd 调用，清除更多设置里面内容

        window.clearMoreSetting = function () {
            localStorage.setItem('renderParamsMore', JSON.stringify({}));

            setClearMoreSetting(!clearMoreSetting);
        };

        /**
         * HDD 外部调用：仅同步 Web 面板状态与 localStorage，不回传 setRenderParams。
         * 入参（扁平）：{ id, name, path, rotate, envBright, envReflect, envTone, exteriorBright }
         */
        window.noticeExteriorParams = function (params) {
            try {
                const payload = parseNoticeExteriorParams(params);
                if (!payload) return;

                const { id: exteriorId } = payload;

                let renderParams = {};
                try {
                    renderParams =
                        JSON.parse(
                            localStorage.getItem('renderParams') || '{}'
                        ) || {};
                } catch {
                    renderParams = {};
                }

                let renderParamsMore = {};
                try {
                    renderParamsMore =
                        JSON.parse(
                            localStorage.getItem('renderParamsMore') || '{}'
                        ) || {};
                } catch {
                    renderParamsMore = {};
                }

                const morePatch = {};
                [
                    'envBright',
                    'envReflect',
                    'envTone',
                    'exteriorBright',
                ].forEach(key => {
                    if (payload[key] !== undefined) {
                        morePatch[key] = payload[key];
                    }
                });

                renderParamsMore[exteriorId] = {
                    ...(renderParamsMore[exteriorId] || {}),
                    ...morePatch,
                };
                localStorage.setItem(
                    'renderParamsMore',
                    JSON.stringify(renderParamsMore)
                );

                const br = renderParamsBridgeRef.current || {};
                const curExteriorRow = (br.exteriorList || []).find(
                    v => v.value === exteriorId || v.id === exteriorId
                );
                const exteriorValue = curExteriorRow?.value ?? exteriorId;

                const rotateVal =
                    payload.rotate !== undefined && payload.rotate !== null
                        ? +payload.rotate
                        : renderParams.exterior?.rotate ?? 0;

                const m = renderParamsMore[exteriorId] || {};
                let exteriorBright = m.exteriorBright;
                exteriorBright =
                    +exteriorBright === 0 ? 0 : exteriorBright || 1;
                let envBright = m.envBright;
                envBright =
                    +envBright === 0
                        ? 0
                        : m.envBright === undefined
                        ? 3
                        : m.envBright;
                const envReflect = m.envReflect ?? 3;
                const envTone = m.envTone || 'nature';

                const exteriorPayload = {
                    id: exteriorId,
                    path:
                        payload.path ??
                        curExteriorRow?.image ??
                        renderParams.exterior?.path,
                    rotate: rotateVal,
                    name:
                        payload.name ??
                        curExteriorRow?.commit ??
                        renderParams.exterior?.name,
                    exteriorBright,
                    envBright,
                    envReflect,
                    envTone,
                };

                // 仅 Web 内部缓存，供主面板读取 path/name，不触发 HDD 回传
                localStorage.setItem(
                    'renderParams',
                    JSON.stringify({
                        ...renderParams,
                        exterior: exteriorPayload,
                    })
                );

                suppressHddNotifyFromExternalRef.current = true;
                setExterior(exteriorValue);
                setRotate(rotateVal);

                try {
                    localStorage.setItem(
                        'hddRenderExteriorSync',
                        JSON.stringify({
                            ts: Date.now(),
                            exteriorId,
                            ...morePatch,
                            exterior: exteriorPayload,
                        })
                    );
                } catch (e) {}
            } catch (e) {
                console.warn('noticeExteriorParams', e);
            }
        };

        document.addEventListener('click', onKeydown);
        // setTimeout(() => {
        //     console.log('noticeExteriorParams');
        //     window.noticeExteriorParams({"envBright":4.000000,"envReflect":3.000000,"envTone":"nature","exteriorBright":1.000000,"id":"city_1","name":"城市白天1","path":"http://10.110.4.104:3000/render/conditions/exteriorView/city_1.jpg","rotate":0.000000});
        // }, 100);
        return () => {
            document.removeEventListener('click', onKeydown);
            try {
                delete window.noticeExteriorParams;
                delete window.noticeLightingList;
            } catch (e) {}
        };
    }, []);

    const onChangeComposition = e => {
        getNewComposition(e.target.value).then(() => {
            initOperateLight();
            setComposition(e.target.value);
            compositionRef.current = e.target.value;
        });
    };

    const [composition, setComposition] = useState('1k');

    const compositionMenu = (
        <Radio.Group
            onChange={onChangeComposition}
            defaultValue={1}
            value={composition}>
            {compositionList.map(item => (
                <Radio.Button value={item.value} key={item.value}>
                    {item.compositionW + ' : ' + item.compositionH}
                </Radio.Button>
            ))}
        </Radio.Group>
    );

    const [resolution, setResolution] = useState('1');

    const initOperateLight = () => {
        setOperateLight({
            status: 'none',
            id: lightList[0]?.id,
            name: lightList[0]?.name,
        });
    };

    const getNewComposition = composition => {
        return getCondition({ renderType, compositionValue: composition }).then(
            res => {
                console.log('res', res);
                if (!res.data) return;
                setResolutionList(res.data.resolution);
            }
        );
    };

    const onChangeResolution = e => {
        setResolution(e.target.value);
        initOperateLight();
    };

    const resolutionMenu = (
        <Radio.Group
            onChange={onChangeResolution}
            defaultValue="1"
            value={resolution}>
            {resolutionList.map(item => (
                <Radio.Button value={item.value} key={item.value}>
                    <div className="display-resolution">
                        <div className="resolution-name">
                            {item.resolutionKresolution + item.resolutionName}
                        </div>
                        <div className="resolution-info">
                            {item.resolutionW + '*' + item.resolutionH}
                        </div>
                    </div>
                    <div className="num">
                        {item.rest === 'all' ? '无限' : item.rest}
                    </div>
                </Radio.Button>
            ))}
        </Radio.Group>
    );

    const [lightList, setLightList] = useState([]);

    const [rotate, setRotate] = useState(0);

    const onRotateChange = value => {
        setRotate(value);
        initOperateLight();
    };

    const onSelectExterior = value => {
        setExterior(value);
        initOperateLight();
    };

    const [operateLight, setOperateLight] = useState({
        status: 'none',
        id: lightList[0]?.id,
        name: lightList[0]?.name,
    });

    const onAddLight = () => {
        setOperateLight({
            status: 'create',
            id: '',
            name: '',
        });
    };

    const [formRef] = Form.useForm();

    const onCancel = () => {
        formRef.resetFields();
        setRenameVisible(false);
    };

    const onEditLight = item => {
        setRenameVisible(true);
        formRef.setFieldsValue({
            id: item.id,
            name: item.name,
        });
    };

    const onCopyLight = item => {
        setOperateLight({
            status: 'copy',
            id: item.id,
            name: item.name,
        });
    };

    const onLightActive = item => {
        setOperateLight({
            status: 'active',
            id: item.id,
            name: item.name,
        });

        setLightList(prev => {
            let next = [...prev];
            next.map(v => {
                if (v.id === item.id) {
                    v.active = 1;
                } else {
                    v.active = 0;
                }
                return v;
            });
            return next;
        });
    };

    const onDeleteLight = item => {
        Modal.confirm({
            title: null,
            icon: null,
            content: `确认删除【${item.name}】布光方案吗`,
            okText: '确认',
            cancelText: '取消',
            onOk: close => {
                const index = lightList.findIndex(v => v.id === item.id);
                const remaining = lightList.filter(v => v.id !== item.id);

                setOperateLight({
                    status: 'delete',
                    id: item.id,
                    name: item.name,
                });
                setLightList(prev => {
                    let next = [...prev];
                    let idx = prev.findIndex(v => v.id === item.id);
                    next.splice(idx, 1);
                    // 删除后自动选择：优先上一个，没有上一个则选下一个
                    if (next.length > 0) {
                        let selectIdx = index > 0 ? index - 1 : 0;
                        next.forEach((v, i) => {
                            v.active = i === selectIdx ? 1 : 0;
                        });
                    }
                    return next;
                });
                // 删除后自动激活邻近方案
                if (remaining.length > 0) {
                    let selectIdx = index > 0 ? index - 1 : 0;
                    let selectItem = remaining[selectIdx];
                    setTimeout(() => {
                        setOperateLight({
                            status: 'active',
                            id: selectItem.id,
                            name: selectItem.name,
                        });
                    }, 0);
                }
                close();
            },
            onCancel: close => {
                close();
            },
        });
    };

    const [renameVisible, setRenameVisible] = useState(false);

    const renderParamsBridgeRef = useRef({});

    function onSubmitName(values) {
        setOperateLight({
            status: 'edit',
            id: values.id,
            name: values.name,
        });

        setLightList(prev => {
            let next = [...prev];
            next.map(v => {
                if (v.id === values.id) {
                    v.name = values.name;
                }
                return v;
            });
            return next;
        });

        setRenameVisible(false);
    }

    useEffect(() => {
        const curComposition = compositionList.find(
            v => v.value === composition
        );
        const curResolution = resolutionList.find(v => v.value === resolution);
        const curExterior = exteriorList.find(v => v.value === exterior);
        const renderParamsMore = JSON.parse(
            localStorage.getItem('renderParamsMore')
        );

        console.log('renderParamsMore', renderParamsMore);

        if (
            (!curComposition && +renderType === 0) ||
            !curResolution ||
            !curExterior
        ) {
            if (suppressHddNotifyFromExternalRef.current) {
                suppressHddNotifyFromExternalRef.current = false;
            }
            return;
        }

        try {
            let savedParams = {};
            try {
                savedParams =
                    JSON.parse(localStorage.getItem('renderParams') || '{}') ||
                    {};
            } catch {
                savedParams = {};
            }
            const savedExterior =
                savedParams.exterior?.id === curExterior?.value
                    ? savedParams.exterior
                    : null;

            let exteriorBright =
                renderParamsMore?.[curExterior.value]?.exteriorBright;

            exteriorBright = +exteriorBright === 0 ? 0 : exteriorBright || 1;

            let envBright = renderParamsMore?.[curExterior.value]?.envBright;

            envBright =
                +envBright === 0
                    ? 0
                    : renderParamsMore?.[curExterior.value]?.envBright || 3;

            const params = {
                resolutionKresolution: curResolution?.resolutionKresolution,
                resolutionName: curResolution?.resolutionName,
                resolutionW: curResolution?.resolutionW,
                resolutionH: curResolution?.resolutionH,
                compositionW: curComposition?.compositionW,
                compositionH: curComposition?.compositionH,
                lightingPlan: operateLight,
                exterior: {
                    id: curExterior?.value,
                    path: savedExterior?.path || curExterior?.image,
                    rotate: rotate,
                    name: savedExterior?.name || curExterior?.commit,
                    exteriorBright,
                    envBright,
                    envReflect:
                        renderParamsMore?.[curExterior.value]?.envReflect || 3,
                    envTone:
                        renderParamsMore?.[curExterior.value]?.envTone ||
                        'nature',
                },
            };
            localStorage.setItem('renderParams', JSON.stringify(params));
            console.log('setRenderParams params', params);
            if (!suppressHddNotifyFromExternalRef.current) {
                window.external.DispatchFun(
                    'LeftPanel',
                    'setRenderParams',
                    JSON.stringify(params)
                );
            } else {
                suppressHddNotifyFromExternalRef.current = false;
            }
        } catch (err) {
            console.log(err);
        }
    }, [
        composition,
        exterior,
        resolution,
        rotate,
        operateLight,
        clearMoreSetting,
    ]);

    renderParamsBridgeRef.current = {
        composition,
        resolution,
        rotate,
        operateLight,
        compositionList,
        resolutionList,
        exteriorList,
        exterior,
        renderType,
    };

    const onShowWindow = e => {
        e.stopPropagation();
        e.preventDefault();
        console.log(111);

        var bounding = e.target.getBoundingClientRect();
        try {
            window.external.DispatchFun(
                'Atlas',
                'ShowMoreSettingWindow',
                JSON.stringify({
                    PosX: bounding.left,
                    PosY: bounding.top,
                })
            );
        } catch {}
    };

    return (
        <div className="render-params">
            <Collapse
                bordered={false}
                defaultActiveKey={['1', '2', '3', '4']}
                expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                className="render-params-collapse"
                expandIconPosition="right">
                <Panel
                    header="清晰度"
                    key="1"
                    className="clarity"
                    extra={extra}>
                    {resolutionMenu}
                </Panel>
                {+renderType === 0 && (
                    <Panel header="构图" key="2" className="composition">
                        {compositionMenu}
                    </Panel>
                )}
                <Panel header="布光方案" key="3" className="lighting-plan">
                    <div className="lighting-plan-content">
                        <div className="add-light" onClick={onAddLight}>
                            <span className="filled icon-plus"></span>
                            <span>创建布光方案</span>
                        </div>
                        {lightList.map((item, index) => (
                            <div className="lighting-plan-item" key={index}>
                                <div
                                    className={`img-wrap ${
                                        +item.active === 1 ? 'active' : ''
                                    }`}
                                    onClick={() => onLightActive(item)}>
                                    <img src={item.img}></img>
                                </div>
                                <div className="lighting-plan-name">
                                    <div className="word">
                                        <div className="word-name">
                                            {item.name}
                                        </div>
                                    </div>
                                    <div className="operate-item">
                                        <div
                                            className="operate-item__edit"
                                            onClick={() => onEditLight(item)}>
                                            <span className="filled icon-pencil"></span>
                                        </div>
                                        <div
                                            className="operate-item__delete"
                                            onClick={() => onCopyLight(item)}>
                                            <span className="filled icon-copy"></span>
                                        </div>
                                        <div
                                            className="operate-item__delete"
                                            onClick={() => onDeleteLight(item)}>
                                            <span className="filled icon-trash"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Panel>
                <Panel header="外景" key="4" className="exterior">
                    <div className="exterior-content">
                        {exteriorList.map((item, index) => (
                            <div
                                className={`exterior-item ${
                                    item.value === exterior ? 'active' : ''
                                }`}
                                key={index}
                                onClick={() => onSelectExterior(item.value)}>
                                <div
                                    className={`exterior-item__img ${
                                        item.value === exterior ? 'active' : ''
                                    }`}>
                                    <img src={item.image}></img>
                                </div>
                                <div className="exterior-item__name">
                                    {item.commit}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="exterior-rotate">
                        <div className="exterior-rotate__item">
                            <div className="exterior-rotate__item__name">
                                外景旋转
                            </div>
                            <div className="exterior-rotate__item__value slider-wrap">
                                <Slider
                                    defaultValue={0}
                                    max={360}
                                    value={rotate}
                                    onChange={onRotateChange}
                                />
                                <div className="exterior-rotate__item__value__input">
                                    <InputNumber
                                        min={0}
                                        max={360}
                                        defaultValue={0}
                                        value={rotate}
                                        onPressEnter={e => e.target.blur()}
                                        onChange={onRotateChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="exterior-setting" onClick={onShowWindow}>
                        <div className="exterior-setting__item">更多设置</div>
                        <RightOutlined />
                    </div>
                </Panel>
            </Collapse>
            <Modal
                title="布光方案名称"
                visible={renameVisible}
                onOk={formRef.submit}
                onCancel={onCancel}
                width={224}>
                <Form form={formRef} onFinish={onSubmitName}>
                    <Form.Item
                        name="name"
                        validateFirst
                        rules={[
                            {
                                required: true,
                                message: '请输入布光方案名称',
                            },
                            {
                                validator: async (rule, value) => {
                                    if (!value) return;
                                    // const val = value.replace(
                                    //     /[\u4e00-\u9fa5]/g,
                                    //     'aa'
                                    // );
                                    if (value.length < 11) {
                                        return Promise.resolve();
                                    }
                                    throw new Error('最多输入10个字符');
                                },
                            },
                        ]}>
                        <Input allowClear maxLength={10}></Input>
                    </Form.Item>
                    <Form.Item name="id" hidden>
                        <Input></Input>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}
